import styled from 'styled-components'



export const Container = styled.div`
    padding-right: 0px;
    padding-left: 0px;
    margin-right: auto;
    margin-left: auto;
    @media (min-width: 768px) {
        width: 750px;
    }
    @media (min-width: 992px) {
        
        width: 970px;
        
    }
    @media (min-width: 1200px) {
        
        width: 1110px;
        
    }
`

export const Containerpreguntas = styled.div`
    padding-right: 10px;
    padding-left: 10px;
    padding-top: 30px;
    padding-bottom: 5px;
    margin-right: auto;
    margin-left: auto;
    @media (min-width: 768px) {
        width: 750px;
        padding-right: 0px;
        padding-left: 0px;
    }
    @media (min-width: 992px) {
        
        width: 970px;
        padding-right: 0px;
        padding-left: 0px;
        
    }
    @media (min-width: 1200px) {
        
        width: 1110px;
        padding-right: 0px;
        padding-left: 0px;
        
    }
`

export const Containertop = styled.div`
    padding-right: 0px;
    padding-left: 0px;
    margin-right: auto;
    margin-left: auto;
    margin-top: 50ox;
    width: 100%;
    @media (min-width: 768px) {
        width: 750px;
        margin-top: 50px;
    }
    @media (min-width: 992px) {
        
        width: 970px;
        margin-top: 50px;
        
    }
    @media (min-width: 1200px) {
        
        width: 1110px;
        margin-top: 50px;
        
    }
`
export const Row = styled.div`
   margin: 0;
   width: 100%;
   padding: 0;
`
export const Colseis = styled.div`
   float: left;
   width: 100%;
   padding-right: 10px;
   padding-left: 10px;
   @media (min-width: 768px) { 
      width: 70%;
      padding-right: 0px;
    padding-left: 0px;
   }
   @media (min-width: 992px) { 
      width: 70%;
      padding-right: 0px;
    padding-left: 0px;
   }
   @media (min-width: 1200px) { 
      width: 70%;
      padding-right: 0px;
      padding-left: 0px;
   }
   
`

export const Coltres = styled.div`
   width: 100%;
   float: left;
   border: #f00 solid px;
   padding-right: 10px;
   padding-left: 10px;
   @media (min-width: 768px) { 
      width: 100%;
      padding-right: 0px;
        padding-left: 0px;
   }
   @media (min-width: 992px) { 
      width: 100%;
      padding-right: 0px;
        padding-left: 0px;
   }
   @media (min-width: 1200px) { 
      width: 100%;
      padding-right: 0px;
        padding-left: 0px;
   }
   
`

export const Linkbtn = styled.span`
    background:#D9A76A;
    color: #fff;
    padding: 5px;
    margin-left: 0px;
    border-radius: 4px;
    display: inline-flex;
    text-transform: uppercase;
    cursor:pointer;
    @media (min-width: 768px) { 
        padding: 5px;
    }
    @media (min-width: 992px) { 
        padding: 14px 22px;
    }
    @media (min-width: 1200px) { 
        padding: 14px 22px;
    }

    svg{
        margin-left:10px;
    }
`
export const Txtinicio = styled.div`
    font-size:20px;
    margin:40px 0;
`









